/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPullToRefresh = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 13v6.585l2.293-2.292 1.414 1.414L12 23.414l-4.707-4.707 1.414-1.414L11 19.585V13zM12 2a9 9 0 0 1 7.231 14.358l-.206.268-1.56-1.252A7 7 0 1 0 5 11c0 1.513.48 2.951 1.355 4.14l.18.234-1.56 1.252A9 9 0 0 1 12 2zm0 4a5 5 0 0 1 4.469 7.245l-.138.256-1.731-1.002a3 3 0 1 0-5.303-.197l.104.197-1.731 1.002A5 5 0 0 1 12 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPullToRefresh as PullToRefresh };
